export const LINKED_SCHEMA_TAG = "linked-ref";
